import styled from 'styled-components';

export const TabTitleWrapper = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 57px;
  min-width: 80px;
  padding: 0 3px;
  background-color: var(--v3-black-4);
`;

export const TabTitle = styled.p<{
  isActive: boolean;
}>`
  font-size: 12px;
  line-height: 16px;
  margin: 4px 0 0 0;
  color: ${props =>
    props.isActive ? 'var(--v3-black-85)' : 'var(--v3-black-45)'};
`;

export const SportContainer = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--v3-black-6);
  background-color: var(--v3-black-0);
`;

export const SportNameContainer = styled.span`
  gap: 4px;
  display: flex;
  align-items: center;
  color: var(--v3-black-85);
`;

export const Header = styled.div`
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
  padding: 0 12px;
`;

export const Title = styled.div`
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.4px;
  color: var(--v3-black-100);
`;

export const Link = styled.span`
  color: var(--v3-black-45);
  letter-spacing: 0.44px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
`;

export const SpinWrapper = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--v3-black-0);
`;

export const SpinCover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: var(--v3-black-0);
`;

export const TabsWrapper = styled.div`
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--v3-black-0);

  & > div {
    height: 100%;

    div[class*='-tabs-content-holder'] {
      overflow: auto;
      height: 100%;
    }
  }

  div[class*='-tabs-tab'] {
    width: 100%;
    margin: 0;
    border: none;
  }

  div[class*='-tabs-tabpane'] {
    width: 100%;
  }

  div[class*='-tabs-content'] {
    width: 100%;
    overflow: auto;
  }

  div .v3-tabs-nav {
    margin: 0;
  }
`;
